module.exports = __webpack_public_path__ + "static/media/1.b4d20cc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-signup-works/1.jpg
// module id = 390
// module chunks = 0